<template>
  <div class="container-fluid">
    <div class="row mobile flex-nowrap">
      <MobileSideBar id="mobile" />
      <SideBar id="desktop" />
      <div class="col bg-light changelog-content">
        <header class="changelog-header"><h1>Muudatuste logi</h1></header>

        <section class="changelog-section">
          <h6>v2.2.7 (23.10.2026)</h6>
          <ul>
            <li>Avalehe tasuliste litsentside hinnang arvestab iga kehtiva litsentsi loomisaega. 30 kalendripäeva pikkust prooviperioodi ei loeta tasuliseks ka hilisema aktiveerimise või suve- ja talveaja vahetuse korral. Selgitati kehtivate ja tasuliste litsentside näitajate tähendust.</li>
            <li>Meeskonnaliikmete lisamisel eemaldatakse kopeeritud telefoninumbritest tühikud ja kõrvalised märgid, kontrollitakse plussmärgi asukohta ning välditakse korduvaid numbreid. Ka server kontrollib telefoninumbri vormingut.</li>
            <li>Liikmete hulgi lisamine jätkub ka üksiku vea korral. Iga ebaõnnestunud liikme juures näidatakse põhjust ning uuesti saab saata ainult ebaõnnestunud kirjed. Kui server kinnitab endise liikmesuse taastamist, kuvatakse see eraldi tulemusena.</li>
            <li>Meeskonnaliikmete tabelisse ja CSV eksporti lisati viimase grupiga liitumise kuupäev („Last group”).</li>
            <li>Litsentside aktiveerimise valik „Needs renewal” näitab nüüd ainult pikendamist vajavaid seotud aktiivseid SIM-e.</li>
            <li>SIM-i detailvaates ei kirjuta varem avatud seadme hilinenud vastused enam üle praeguse seadme andmeid. Viimase seadmeinfo päringule lisati vahemälu vältiv ajatempel.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.2.6 (25.09.2026)</h6>
          <ul>
            <li>Meeskonna litsentside aktiveerimisel kontrollitakse nüüd kasutaja kõige kauem kehtivat litsentsi. Valikud „All team-paid”, „Needs renewal” ja „Custom selection” ei lisa kasutajale meeskonna litsentsi, kui olemasolev litsents kehtib sama kaua või kauem.</li>
            <li>Litsentside aktiveerimise vaates näidatakse iga liikme juures, kas tema litsentsi pikendatakse või on ta juba kaetud. Pärast aktiveerimist kuvatakse lisatud, vahele jäetud ja ebaõnnestunud kirjete arv.</li>
            <li>Kasutajate ja meeskonnaliikmete koondvaadetes näidatakse nüüd kõige kauem kehtivat litsentsi, mitte viimati lisatud kirjet. Kasutaja täielik litsentsiajalugu jääb endiselt lisamisaja järgi, uusim kirje ees.</li>
            <li>Meeskonnaga seotud SIM-ide juures lisati seadme detailvaate avamine ning staatuse, brändi ja kehtivuse visuaalsed tähised.</li>
            <li>Stopped ja Closed olekus seadmed kuvatakse meeskonna detailvaates eraldi ning neid ei kaasata meeskonna litsentsi aktiveerimisel SIM-ide pikendamisse.</li>
            <li>Meeskonnaliikmete lisamise veateateid täiendati HTTP olekukoodi ja serveri tagastatud põhjusega, et olemasolevaid või varem kustutatud õigusi oleks lihtsam tuvastada.</li>
            <li>SIM-i ja kasutaja detailvaadete seosed ühtlustati: seadme saab avada kasutaja või meeskonna kaudu ning sealt saab edasi liikuda omaniku, jagatud kasutajate ja meeskonna detailidesse.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.2.5 (02.09.2026)</h6>
          <ul>
            <li>SIM-ide haldusesse lisati jälgimisseadme detailvaade, mis koondab seadme, omaniku, meeskonna ja jagatud kasutajate andmed.</li>
            <li>Detailvaates kuvatakse seadme värskeim telemeetria: olek, GSM- ja GNSS-signaal, mobiilivõrk, tarkvaraversioon, akupinge koos protsendiga, laadimine, kiirus ja aktiivsus. Viimast infot saab eraldi nupuga värskendada.</li>
            <li>Seadme viimane asukoht kuvatakse koos signaali aja, koordinaatide ja Google Mapsi hübriidkaardiga. Lisatud on seadme saadetud sõnumite ning telefonist saadetud SMS-käskude ajalugu.</li>
            <li>Seadme detailvaates saab muuta SIM-i märkmeid ning avada omaniku, meeskonna ja jagatud kasutajate detailvaated. Omanikku ei korrata jagatud kasutajate nimekirjas.</li>
            <li>Jälgimisseadme detailvaate saab nüüd avada SIM-ide nimekirjast, kiirotsingu tulemustest ning kasutaja ja meeskonna detailvaate seadmete nimekirjast.</li>
            <li>Kasutaja telefonile saab saata teavitusi ja seadme telefonile seadistuskäske SMS-iga. Saatmine toimub Messente kaudu ning küsib enne kinnitust.</li>
            <li>Kiirotsingu tulemuste vaade uuendati ning SIM-i juures kuvatakse seotud meeskond ja detailvaate nupp.</li>
            <li>Interneti pikendamise vaates kuvatakse esmalt kasutaja makstavad ja seejärel meeskonna makstavad SIM-id. Kummaski rühmas järjestatakse aegunud SIM-id kehtivuse lõppemise järgi, kõige varem aegunud SIM esimesena. Teavituste sõnastust parandati ja eemaldati e-posti automaatset allkirja kordavad meeskonna-allkirjad.</li>
            <li>Vasakpoolne menüü püsib lehe kerimisel nähtaval ning meeskondade nimekirja Details-veerg joondub korrektselt.</li>
            <li>Arenduskeskkonnas eraldati TIW API ja kasutajaliides portidele 3001 ja 3002 ning parandati kohaliku serveri käivitamine.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.2.4 (19.08.2026)</h6>
          <ul>
            <li>Kasutaja ja meeskonna detailvaated kujundati ümber ühtseks kaardipõhiseks haldusvaateks. Sektsioonid, tabelid, nupud ja dialoogid kasutavad nüüd sama värvi- ning kujunduskeelt.</li>
            <li>Kasutaja detailvaatele lisati Places'i aktiivsete asukohtade näitajad, kasutajaga seotud jälgimisseadmete päring ning otsetee meeskonna detailvaatesse.</li>
            <li>Märkme lisamisel saab nüüd märkme salvestada ja avada kasutaja e-posti aadressile eeltäidetud kirja. Litsentsid, seadmed ja märkmed kuvatakse uusimast vanimani.</li>
            <li>Meeskonna seadete, liikmete lisamise ja litsentside aktiveerimise dialoogid uuendati. Meeskonna litsentside liikmete ja seotud SIM-ide tabelid kasutavad detailvaate tabelistiili.</li>
            <li>Kasutajate, meeskondade ja SIM-ide nimekirjavaated said uue päise, tööriistariba, veerufiltrite kaardi ning ühtse tabeliraami. Päistes kuvatakse viimase andmeuuenduse kuupäev ja kellaaeg.</li>
            <li>Uuendati avalehe kiirtööriistad, analüütika, interneti pikenduste teavituste vaade, Add SIMs dialoog ja Muudatuste logi vaade.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.2.3 (18.08.2026)</h6>
          <ul>
            <li>Kasutaja detailvaates taastatud PIN-koodiga Huntloci portaali sisselogimine.</li>
            <li>Portaali autentimine viidud vastavusse serveris varem töötanud lahendusega.</li>
            <li>Portaali sisselogimise veateated täiendatud HTTP olekukoodiga, et võimalikke ühendusprobleeme oleks lihtsam tuvastada.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.2.2 (18.08.2026)</h6>
          <ul>
            <li>Lisatud käsitsi juhitav jälgimisseadme interneti pikendamise teavituste vaade.</li>
            <li>Vaates saab saata seadme- ja SIM-ipõhise makselingiga e-kirja, muuta teavituse keelt ning salvestada saatmise kasutaja Notes'i.</li>
            <li>Näidatakse kasutajat, tema telefoninumbrit, SIM-i kehtivust, Notes'i, brändi, arveldusviisi ja eelmist teavituse saatmiskuupäeva.</li>
            <li>Lisatud aegunud, kuid aktiivsete SIM-ide sulgemishoiatuse teavitus: pikendamata jätmisel suletakse SIM 7 päeva pärast.</li>
            <li>Huntloci ja Doglo seadmed on teavituste vaates brändivärviga eristatavad.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.2.1 (18.08.2026)</h6>
          <ul>
            <li>Kasutaja detailvaates kuvatakse nüüd kasutajaga seotud jälgimisseadmed koos SIM-i kehtivuse, staatuse, brändi ja märkmetega.</li>
            <li>SIM-ide halduse Actions veergu lisati peaikoon: IMEI järgi leitakse seadme omanik ning avatakse tema kasutaja detailvaade.</li>
            <li>Seadme omaniku avamisel kuvatakse laadimisvaade ning juba laaditud omaniku- ja kasutajaandmeid kasutatakse mälust, et korduvad avamised oleksid kiiremad.</li>
            <li>Kasutaja detailvaate e-posti aadress on klikitav link.</li>
            <li>Kasutaja detailvaate komponent on ühine kasutajate ja meeskonnaliikmete vaadetes ning jälgimisseadmete päring käivitatakse ainult detailvaate avamisel.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.1.3 (03.08.2026)</h6>
          <ul>
            <li>Lisatud TIW adminide halduse vaade.</li>
            <li>TIW ligipääsule lisatud täiendavad turvakontrollid: lubatud hostid, HTTPS-nõue ja iframe'is avamise piirang.</li>
            <li><code>herko@huntloc.com</code> on superadmin ning vaikimisi lubatud TIW adminide hulka on lisatud ka teised tööks vajalikud kontod.</li>
            <li>Adminide nimekirja laadimine parandatud: vaikimisi lubatud kontod kuvatakse kohe ka siis, kui taustal tehakse lisapäringuid.</li>
            <li>Employee vaade puhastatud tehnilisest taustainfost, et kasutajale oleks näha ainult vajalik haldusinfo.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.1.2 (10.07.2026)</h6>
          <ul>
            <li>Meeskonna litsentsi aktiveerimisel lisatud valikud:
              <br>Valik 1 võtab kõik täisliikmed lisamise valikusse.
              <br>Valik 2 võtab kõik täisliikmed, kellel on litsents väiksem kui meeskonna oma.
              <br>Valik 3 annab ette kõik liikmed ning on võimalik ise valida, kes saab litsentsi.
            </li>
            <li>Meeskonna vaates lisatud litsentsi kuupäev avavaates koos filtreerimise ja sorteerimisega.</li>
            <li>SIM vaates kuupäeva valik parandatud: vasakpoolne "alates" sisend lubab sama päeva vastusena, parempoolne "kuni" ei luba järgmist päeva.</li>
            <li>SIM muutmisel lubatud 1oT operaatori valik.</li>
            <li>Telefoninumbrid, mis algavad <code>+380</code>, lähevad kirja Ukraina telefoninumbrite nimekirja.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v2.1.1 (16.06.2026)</h6>
          <ul>
            <li>Meeskonna tabelisse lisatud uus Members veerg, mis näitab kõikide liikmete koguarvu.</li>
            <li>Meeskonna vaates värvitakse Valid until kuupäevad punaseks, kui kehtivus on läbi, ja kollaseks, kui lõpuni on jäänud kuni 30 päeva.</li>
          </ul>
        </section>

        <section class="changelog-section">
          <h6>v1.x (varasem seis)</h6>
          <ul>
            <li>2000+ kasutajat ja nende arv salvestatakse, et võimaldada kohest ligipääsu lehele. Ülejäänud kasutajad tõmmatakse taustal ning valmisolekul tulevad olemasolevatele andmetele juurde.</li>
            <li>Iga leht, mis kasutab kasutajate andmeid, näitab ka seda, kuna lehte viimati uuendati.</li>
            <li>Portaali logimine parandatud. Enam ei avane lisaleht portaali avamisel kasutaja lehelt ning portaali auth juures on eraldi nupp portaali lehele.</li>
            <li>Litsentside lisamine parandatud. Mitme litsentsi (10+) lisamine toimib edukalt nii meeskonna kui ka kasutajate lehel.</li>
            <li>CSV allalaadimisel parandatud viga, mis ei võtnud search rea otsingu tulemusi kaasa.</li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar.vue'
import MobileSideBar from '@/components/MobileSideBar.vue'

export default {
  name: 'news',
  components: {
    SideBar,
    MobileSideBar
  }
}
</script>

<style scoped>
#mobile {
  display: none;
}

.changelog-content {
  padding: 4px 18px 18px;
  color: #202629;
}

.changelog-header {
  margin: 0 -18px 18px;
  padding: 20px 22px;
  border-left: 4px solid #f56600;
  border-radius: 0 0 9px 9px;
  background: #202629;
  color: #fff;
}

.changelog-header h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
}

.changelog-section {
  max-width: 1080px;
  margin-bottom: 12px;
  padding: 14px;
  border: 1px solid #e1e5e6;
  border-radius: 9px;
  background: #fbfcfc;
}

.changelog-section h6 {
  color: #202629;
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 10px;
}

.changelog-section ul {
  margin: 0;
  padding-left: 18px;
  color: #40545e;
  font-size: 11px;
}

.changelog-section li + li {
  margin-top: 0.45rem;
}

@media screen and (max-width: 768px) {
  #mobile {
    display: flex;
  }

  #desktop {
    display: none;
  }

  .mobile {
    display: grid;
  }

  .changelog-content {
    padding: 4px 10px 12px;
  }

  .changelog-header {
    margin: 0 -10px 14px;
    padding: 16px;
  }
}
</style>
